module.exports = __webpack_public_path__ + "img/mailSent.067b7ff1.svg";